<template>
  <div class="lds-ellipsis">
    <div :style="dotStyle"></div>
    <div :style="dotStyle"></div>
    <div :style="dotStyle"></div>
    <div :style="dotStyle"></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    color: {
      type: String,
      default: "#000",
    },
  },
  computed: {
    dotStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },
};
</script>

<style scoped>
.lds-ellipsis {
  display: inline-block !important;
  position: relative !important;
  width: 80px !important;
  height: 80px !important;
}
.lds-ellipsis div {
  position: absolute !important;
  top: 33px !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 50% !important;
  animation-timing-function: cubic-bezier(0, 1, 1, 0) !important;
}
.lds-ellipsis div:nth-child(1) {
  left: 8px !important;
  animation: lds-ellipsis1 0.6s infinite !important;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px !important;
  animation: lds-ellipsis2 0.6s infinite !important;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px !important;
  animation: lds-ellipsis2 0.6s infinite !important;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px !important;
  animation: lds-ellipsis3 0.6s infinite !important;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>

